import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ onConsultationClick, onVacancyClick }) => {
  return (
    <section className="relative min-h-screen lg:min-h-screen flex items-center overflow-hidden pt-24 pb-16 sm:pt-20 sm:pb-12">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_d9f78479-b1ec-4ee5-97ee-4214e41b9e45/artifacts/uaz9354l_image.png"
          alt="Premium Restaurant Interior"
          className="w-full h-full object-cover"
        />
        {/* Charcoal gradient overlay - darker on left, clearer on right.
            Inline style so it never depends on Tailwind arbitrary-value CSS being present. */}
        <div
          className="absolute inset-0"
          data-testid="hero-overlay"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(33,36,44,0.92) 0%, rgba(33,36,44,0.78) 50%, rgba(33,36,44,0.45) 100%)'
          }}
        ></div>
      </div>

      {/* Content - Left Aligned */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-8 sm:py-20 w-full">
        <div className="max-w-3xl">
          {/* Small yellow heading above main heading */}
          <p className="text-[#FFD000] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-4">
            HOSPITALITY RECRUITMENT & WORKFORCE RISK
          </p>
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-normal text-white mb-4 sm:mb-6 leading-tight" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale' }}>
            Stop Replacing the Same Role Every 6 Months.
          </h1>
          <p className="text-sm sm:text-lg lg:text-xl text-gray-400 mb-6 sm:mb-10 leading-relaxed">
            Founder-led hospitality recruitment designed to reduce turnover, behavioural risk, operational disruption, and improve reliability in restaurants and hospitality groups across South Africa.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button 
              onClick={onVacancyClick}
              size="lg"
              className="bg-[#FFD000] hover:bg-[#FFD000]/90 text-black font-semibold px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg transition-all duration-300 hover:scale-105"
            >
              Discuss a Vacancy
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            
            <Button 
              onClick={onConsultationClick}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg transition-all duration-300"
            >
              Request a Confidential Consultation
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - hidden on mobile */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce hidden sm:block">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/30 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
